


































































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import GeneralProductSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/GeneralProduct/GeneralProductSettingsEditDialog.vue';
import ProductState from '@/components/Products/ProductState.vue';
import ProductPublishDialog from '@/components/Products/ProductIssues/ProductIssueCreateDialog.vue';
import TargetCustomerType from '@/models/Products/TargetCustomerType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'ProductGeneralDetails', components: { ProductState, GeneralProductSettingsEditDialog, ProductPublishDialog } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    get product() {
        return ProductDetailsModule.product;
    }

}
